import { render, staticRenderFns } from "./local-datatable.vue?vue&type=template&id=38cf7994&"
import script from "./local-datatable.vue?vue&type=script&lang=js&"
export * from "./local-datatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports